import React, { 
    useContext, 
    useEffect, 
    useState, 
    useRef 
} from "react";
import { useNavigate, useParams } from "react-router";
import { useMutation } from '@tanstack/react-query';

import { refetchBasketData, NotificationContext, handleError } from '../router'

import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";
import * as OPTIONS from "../option-fields";

import LoadingIndicator from '../components/loading-indicator';
import SelectBestAvailablePrice from './select-best-available-price'


export default function PurchaseByPrice(props) {

    const {notification, setNotification} = useContext(NotificationContext);
    const { instanceId } = useParams();
    let navigate = useNavigate();

    const [priceListOpen, setPriceListOpen] = useState(false);
    const [selectedPrice, setSelectedPrice] = useState(null);
    const [pricesPending, setPricesPending] = useState(false);
    const [loadingAllPrices, setLoadingAllPrices] = useState(true);

    const pricesForm = useRef(null);

    // Because the selected price needs to affect the button underneath the list the selection needs to happen here and not in <SelectBestAvailablePrice />
    const addBestAvailable = useMutation({
        mutationFn: () => QUERIES.addBestAvailable(props.ticketQuantity, selectedPrice.band_ids),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchBasketData();
            navigate(`/book-online/${instanceId}/edit-tickets`);
        },
    });

    useEffect(() => {
        // Remove selected price if ticket amount changes
        setSelectedPrice(null);
        pricesForm.current?.reset();
    }, [props.ticketQuantity]);

    useEffect(() => {
        if (!pricesPending) return;
        // Pass loading states from SelectBestAvailablePrice components.
        // If any are pending set a loading state for them all.
        const any_loading = Object.values(pricesPending).some(isLoading => isLoading);
        setLoadingAllPrices(any_loading);
    }, [pricesPending]);

    return (
        <div className="booking-pathway__select-quantity--price-panel">
            <button className='btn btn--primary booking-pathway__select-quantity--price-panel-button' type="button" onClick={() => setPriceListOpen((prev) => !prev)} aria-expanded={priceListOpen} aria-controls="priceListDisclosure">
                Choose by price
            </button>
            <div id="priceListDisclosure" className="booking-pathway__select-quantity--pricelist--panel" aria-hidden={!priceListOpen}>
                <h3 className='sr-text'>Prices</h3>
                {props.bandsByPrice?.length ?
                    <form ref={pricesForm} className="booking-pathway__pricelist grid">
                        {loadingAllPrices &&
                            <LoadingIndicator />
                        }
                        {props.bandsByPrice.map((band) => (
                            <SelectBestAvailablePrice key={band.amount} 
                                        band={band} 
                                        priceListOpen={priceListOpen} 
                                        selectedPrice={selectedPrice}
                                        setSelectedPrice={setSelectedPrice}
                                        ticketQuantity={props.ticketQuantity}
                                        pricesPending={pricesPending}
                                        setPricesPending={setPricesPending}
                                        loadingAllPrices={loadingAllPrices} />
                        ))}
                    </form>
                : 
                    <LoadingIndicator /> 
                }
                { selectedPrice ? 
                    <button className='btn btn--primary' 
                            type="button" 
                            onClick={() => addBestAvailable.mutateAsync()}
                            disabled={addBestAvailable.isPending}>
                        Select x{props.ticketQuantity} £{selectedPrice.amount} seats
                        {addBestAvailable.isPending &&
                            <LoadingIndicator />
                        }
                    </button>
                : 
                    <p className='btn disabled'>Select seats</p>
                }
                {OPTIONS.concessionMessage.text ?
                    <p className='booking-pathway__info-text'>{OPTIONS.concessionMessage.text.innerText}</p>
                :null}
            </div>
        </div>
    )
}
